


























import { Component, Vue, Emit, Watch, Prop } from "vue-property-decorator";
import rest from "@/rest";
// components
// interfaces
import { namespace } from "vuex-class";
import { ExerciseVM } from "@/interfaces/ExerciseVM";
import { CourseElementVm } from "@/interfaces/CourseElementVm";
import CompSurveySlider from "../ExerciseComponents/CompSurveySlider.vue";

const globals = namespace("globals");

@Component({
  components: {
    CompSurveySlider,
  },
})
export default class SliderElement extends Vue {
  @Prop() element!: CourseElementVm;

  @globals.Getter selectedExercise!: ExerciseVM;

  isBusy = false;
  showHtmlEditor = false;

  mounted() {}

  onChanged(value: number) {
    this.element.preset = value;
  }

  // get compSettings() {
  //   return `{ enableZoom: ${this.element.enableZoom} }`;
  // }
}
